import { render, staticRenderFns } from "./quotationList.vue?vue&type=template&id=74a38872&"
import script from "./quotationList.vue?vue&type=script&lang=js&"
export * from "./quotationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a38872')) {
      api.createRecord('74a38872', component.options)
    } else {
      api.reload('74a38872', component.options)
    }
    module.hot.accept("./quotationList.vue?vue&type=template&id=74a38872&", function () {
      api.rerender('74a38872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/Quotation/components/quotationList.vue"
export default component.exports